import styled, { css } from "styled-components"

export const Wrapper = styled.div`
  height: 100vh;
`

export const Backdrop = styled.div`
  position: fixed;
  display: none;
  visibility: hidden;
  overflow: scroll;
  top: 0;
  left: 0;
  width: 100%;
  min-height: 100%;
  background: rgb(0 0 0);
  -webkit-transition: 0.25s ease;
  transition: 0.25s ease;
  opacity: 0.5;
  z-index: 1;
  ${(props) =>
    props.isShownSidebarMobile
      ? css`
          display: block;
          visibility: visible;
          opacity: 0.5;
        `
      : ``};
`

export const Navbar = styled.div`
  background: #5b9ae4;
  max-width: 225px;
  background: linear-gradient(45deg, #5b9ae4 0, #9aa6ed 75%);
`

export const MainWindow = styled.div`
  width: 100%;
`
